import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button, Link } from "@mui/material";
const ProductLinkButton = ({ ...props }) => {
  return (
    <Button
      variant="text"
      {...props}
      component={Link}
      sx={{ textTransform: "none" }}
    >
      <OpenInNewIcon sx={{ fontSize: "18px" }} />
      &nbsp;
      {props.title}
    </Button>
  );
};

export default ProductLinkButton;
